import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Caption from './caption';
import LeftContent from './leftContent';
import RightContent from './rightContent';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { captionData, leftContentData, rightContentData } = content;

        return (
            <div className={styles.content}>
                <Caption content={captionData} />
                <LeftContent content={leftContentData} />
                <RightContent content={rightContentData} />
                <div className="clear" />
            </div>
        );
    }
}

export default Content;
